import React from "react";
import { Redirect, useLocation } from "react-router-dom";

import { isAuthenticated, userHasGroup } from "api";
import { useAskAccess } from "hooks/ask/useAgentCapabilities";
import AskLoading from "pages/ask/AskLoading";

/**
 * The page a signed-in reader lands on when nothing names one: Ask for those who may ask, and
 * otherwise the first product they hold, Map Search before OPTM. Map Search counts BASIC, as the
 * sidebar does, and is also where a reader who holds neither lands.
 */
export const landingRoute = (canAsk) => {
    if (canAsk) return "/ask";
    const hasMapSearch = userHasGroup("MAP-SEARCH") || userHasGroup("BASIC");
    if (!hasMapSearch && userHasGroup("OPTM")) return "/optm";
    return "/map/search";
};

/**
 * "/", which every "take me home" goes through: after login, after a magic link, when the
 * password reset modal closes. Waits for the server to say whether this reader may ask, since
 * landing on Ask without it is a page of disabled controls.
 *
 * The query and hash come along, so `/?password_reset_modal=true` still opens the modal on
 * whichever page this lands on.
 */
export default function HomeRedirect() {
    const location = useLocation();
    const signedIn = Boolean(isAuthenticated());
    const { allowed, settled } = useAskAccess({ enabled: signedIn });

    if (!signedIn) return <Redirect to="/login" />;
    if (!settled) return <AskLoading />;
    return <Redirect to={{ pathname: landingRoute(allowed), search: location.search, hash: location.hash }} />;
}
